import "./FloridaKeysHomeInspector.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ResidentialExperience from "./sections/ResidentialExperience";
import UniversityOverview from "./sections/UniversityOverview";
import StayWithUs from "./sections/StayWithUs";
import Footer from "@/reusable_sections/Footer";
export default function FloridaKeysHomeInspectorPage() {
  return <div>
      <Header />
      <Hero />
      <ResidentialExperience />
      <UniversityOverview />
      <StayWithUs />
      <Footer />
    </div>;
}